export const countryCodes = [
  { code: "1", label: "US / Canada (+1)", flag: "🇺🇸" },
  { code: "7", label: "Russia / Kazakhstan (+7)", flag: "🇷🇺" },
  { code: "20", label: "Egypt (+20)", flag: "🇪🇬" },
  { code: "27", label: "South Africa (+27)", flag: "🇿🇦" },
  { code: "30", label: "Greece (+30)", flag: "🇬🇷" },
  { code: "31", label: "Netherlands (+31)", flag: "🇳🇱" },
  { code: "32", label: "Belgium (+32)", flag: "🇧🇪" },
  { code: "33", label: "France (+33)", flag: "🇫🇷" },
  { code: "34", label: "Spain (+34)", flag: "🇪🇸" },
  { code: "39", label: "Italy (+39)", flag: "🇮🇹" },
  { code: "44", label: "UK (+44)", flag: "🇬🇧" },
  { code: "49", label: "Germany (+49)", flag: "🇩🇪" },
  { code: "52", label: "Mexico (+52)", flag: "🇲🇽" },
  { code: "55", label: "Brazil (+55)", flag: "🇧🇷" },
  { code: "61", label: "Australia (+61)", flag: "🇦🇺" },
  { code: "62", label: "Indonesia (+62)", flag: "🇮🇩" },
  { code: "63", label: "Philippines (+63)", flag: "🇵🇭" },
  { code: "64", label: "New Zealand (+64)", flag: "🇳🇿" },
  { code: "65", label: "Singapore (+65)", flag: "🇸🇬" },
  { code: "81", label: "Japan (+81)", flag: "🇯🇵" },
  { code: "82", label: "South Korea (+82)", flag: "🇰🇷" },
  { code: "86", label: "China (+86)", flag: "🇨🇳" },
  { code: "90", label: "Turkey (+90)", flag: "🇹🇷" },
  { code: "91", label: "India (+91)", flag: "🇮🇳" },
  { code: "92", label: "Pakistan (+92)", flag: "🇵🇰" },
  { code: "93", label: "Afghanistan (+93)", flag: "🇦🇫" },
  { code: "94", label: "Sri Lanka (+94)", flag: "🇱🇰" },
  { code: "95", label: "Myanmar (+95)", flag: "🇲🇲" },
  { code: "98", label: "Iran (+98)", flag: "🇮🇷" },
  { code: "212", label: "Morocco (+212)", flag: "🇲🇦" },
  { code: "213", label: "Algeria (+213)", flag: "🇩🇿" },
  { code: "216", label: "Tunisia (+216)", flag: "🇹🇳" },
  { code: "218", label: "Libya (+218)", flag: "🇱🇾" },
  { code: "254", label: "Kenya (+254)", flag: "🇰🇪" },
  { code: "255", label: "Tanzania (+255)", flag: "🇹🇿" },
  { code: "256", label: "Uganda (+256)", flag: "🇺🇬" },
  { code: "260", label: "Zambia (+260)", flag: "🇿🇲" },
  { code: "234", label: "Nigeria (+234)", flag: "🇳🇬" },
  { code: "971", label: "UAE (+971)", flag: "🇦🇪" },
  { code: "972", label: "Israel (+972)", flag: "🇮🇱" },
  { code: "973", label: "Bahrain (+973)", flag: "🇧🇭" },
  { code: "974", label: "Qatar (+974)", flag: "🇶🇦" },
  { code: "975", label: "Bhutan (+975)", flag: "🇧🇹" },
  { code: "977", label: "Nepal (+977)", flag: "🇳🇵" },
  { code: "880", label: "Bangladesh (+880)", flag: "🇧🇩" },
  { code: "962", label: "Jordan (+962)", flag: "🇯🇴" },
  { code: "966", label: "Saudi Arabia (+966)", flag: "🇸🇦" },
  { code: "968", label: "Oman (+968)", flag: "🇴🇲" },
  { code: "994", label: "Azerbaijan (+994)", flag: "🇦🇿" },
  { code: "998", label: "Uzbekistan (+998)", flag: "🇺🇿" },
];
